export const lang = {
    "item1":"~에 대한",
    "item2":"상품과 서비스",
    "item3":"문의하기",
    "intro1":"NDC(New Distribution Capability)는 IATA(International Air Transport Association)의 새로운 유통 표준으로, 항공사는 NDC 표준을 통해 에이전트에게 풍부한 상품 정보, 개인화된 상품 및 완벽한 서비스 기능을 제공할 수 있습니다.",
    "intro2":"SmartNDC는 항공사 NDC 서비스의 애그리게이터로서 에이전트가 항공사의 NDC와 연결할 수 있도록 지원하여 간단하고 풍부한 JSON API 인터페이스, 온라인 예약 도구, 모바일 예약 페이지 등을 제공합니다. 그것은 에이전트의 고객 관리 및 채널 배포 요구를 충족할 수 있습니다. NDC 기반 좌석 선택, 수하물, VIP 룸, 왕복, 다회차 등 지원",    
    "title1":"온라인 예약 도구",
    "subtitle1":"항공사 NDC 상품의 온라인 예약 및 관리는 맞춤화 및 유통의 요구를 충족합니다.",
    "title2":"모바일 예약 페이지",
    "subtitle2":"적응형 모바일 예약 페이지는 모바일 액세스 또는 모바일 애플리케이션에 포함하는 데 편리합니다.",    
    "title3":"간결한 JSON API",
    "subtitle3":"기본 예약 및 발권 요구 사항을 충족하고 개발 및 통합의 복잡성을 줄입니다.",
    "title4":"자세한 JSON API",
    "subtitle4":"항공사 NDC의 모든 기능을 지원하며 다양한 애플리케이션 개발을 용이하게 합니다.",       
    "title5":"선택적 클라우드 서비스",
    "subtitle5":"유연하고 빠른 사용으로 배포 및 운영 비용이 절감됩니다.",
    "title6":"로컬 배포 가능",
    "subtitle6":"개인 데이터의 보안을 보장하기 위해 사용자 정의 및 개발할 수 있습니다.",    
    "title7":"기능 업그레이드",
    "subtitle7":"NDC 기술의 발전에 적응하기 위한 지속적인 무료 제품 기능 업그레이드. ",
    "title8":"기술 서비스",
    "subtitle8":"중단 없는 작동을 보장하는 7*24시간 기술 서비스. ",        
    "copyright":"Beijing DianDong ChuangXiang Technology Co., Ltd.", 
    "c_name":"이름*", 
    "c_email":"우편*", 
    "c_phone":"전화*", 
    "c_message":"컨설팅 정보*", 
    "c_send":"보내다", 
}